import { ChartConfiguration, LinearScaleOptions } from 'chart.js';
import { USAGE_CHART, USAGE_CHART_X_AXIS, USAGE_CHART_Y_AXIS } from '@markant-platform/usage/feature-usage-report';

export const USAGE_CHART_WIDGET_X_AXIS: LinearScaleOptions = {
  ...USAGE_CHART_X_AXIS,
  grid: {
    display: false,
  },
} as LinearScaleOptions;

export const USAGE_CHART_WIDGET_Y_AXIS: LinearScaleOptions = {
  ...USAGE_CHART_Y_AXIS,
  ticks: {
    display: false,
  },
  grid: {
    display: false,
  },
} as LinearScaleOptions;

export const USAGE_CHART_WIDGET: ChartConfiguration<'line'> = {
  ...USAGE_CHART,
  options: {
    ...USAGE_CHART.options,
    scales: {
      x: USAGE_CHART_WIDGET_X_AXIS,
      y: USAGE_CHART_WIDGET_Y_AXIS,
    },
  },
};
